import React, { useEffect } from "react";
import { Auth } from "aws-amplify";
// eslint-disable-next-line import/no-extraneous-dependencies
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import useIdle from "./useIdle";

const useIdleTimer = ({
  sessionIdleTimeInMs = 5000,
  modalIdleTimeInMs = 30000,
  modalConfig,
  onIdle,
}) => {
  const [isModalOpen, setModalState] = React.useState(false);
  const [remainingIdleTime, setRemainingIdleTime] = React.useState(-1);

  const cookies = new Cookies();

  // eslint-disable-next-line no-unused-vars
  const remainingIdleTimePercent = Math.round(
    (remainingIdleTime / modalIdleTimeInMs) * 100
  );

  const handleClose = () => {
    setModalState(false);
    setRemainingIdleTime(-1);
  };

  const openIdleAlert = () => {
    Swal.fire({
      title: modalConfig?.title ?? " ",
      text: modalConfig?.message ?? " ",
      icon: "warning",
      showCancelButton: true,
      showConfirmButton: false,
      willClose: handleClose,
    });
  };

  const handleIdle = () => {
    if (remainingIdleTime > 0) return;

    if (window.location.pathname === "/login") return;
    openIdleAlert();
    setModalState(true);
    setRemainingIdleTime(modalIdleTimeInMs);

    if (onIdle) {
      onIdle();
    }
  };

  const { isIdle } = useIdle({
    onIdle: handleIdle,
    idleTimeInMs: sessionIdleTimeInMs,
  });

  useEffect(() => {
    let interval;

    if (isIdle && isModalOpen) {
      interval = setInterval(() => {
        setRemainingIdleTime((prevRemainingTime) =>
          prevRemainingTime > 0 ? prevRemainingTime - 1000 : 0
        );
      }, 1000);
    }

    return () => {
      clearInterval(interval);
    };
  }, [isIdle, isModalOpen]);

  useEffect(() => {
    if (isIdle && isModalOpen && remainingIdleTime === 0) {
      Swal.close();
      cookies.set("idle-timeout", true);

      Auth.signOut().then(() => {
        localStorage.clear();
        window.location.replace("/login");
      });
    }
  }, [remainingIdleTime]);

  return {};
};

export default useIdleTimer;
